import { types } from "../types/types";

const initialState = {
  tracking: {}
};
export const trackingHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case types.TRACKING_START_REGISTER:
      return {
        ...state,
        tracking: action.payload
      };

    default:
      return state;
  }
};